/**
 * 订单相关状态枚举 - 页面初始化时调用一次并缓存结果
 * 供订单列表、售后退款等页面渲染筛选下拉框和状态标签使用
 */
import { getRequest } from './http'

const DEFAULT_ORDER_STATUS = [
  { value: 'SUCCESS', label: '支付成功' },
  { value: 'REFUND', label: '转入退款' },
  { value: 'NOTPAY', label: '未支付' },
  { value: 'CLOSED', label: '已关闭' },
  { value: 'REVOKED', label: '已撤销' },
  { value: 'USERPAYING', label: '用户支付中' },
  { value: 'PAYERROR', label: '支付失败' }
]

const DEFAULT_REFUND_STATUS = [
  { value: 'PROCESSING', label: '退款处理中' },
  { value: 'SUCCESS', label: '退款成功' },
  { value: 'ABNORMAL', label: '退款异常' },
  { value: 'CLOSED', label: '退款关闭' },
  { value: 'NONE', label: '无售后' }
]

let cache = null
let fetchPromise = null

/**
 * 获取订单枚举（带缓存）
 * @returns {Promise<{order_status: Array, refund_status: Array}>}
 */
export function getOrderEnums() {
  if (cache) {
    return Promise.resolve(cache)
  }
  if (fetchPromise) {
    return fetchPromise
  }
  fetchPromise = getRequest('/v1/admin/order/enums', {})
    .then((res) => {
      if (res.data && res.data.status === 'success' && res.data.data) {
        const d = res.data.data
        cache = {
          order_status: Array.isArray(d.order_status) && d.order_status.length ? d.order_status : DEFAULT_ORDER_STATUS,
          refund_status: Array.isArray(d.refund_status) && d.refund_status.length ? d.refund_status : DEFAULT_REFUND_STATUS
        }
      } else {
        cache = {
          order_status: DEFAULT_ORDER_STATUS,
          refund_status: DEFAULT_REFUND_STATUS
        }
      }
      return cache
    })
    .catch(() => {
      cache = {
        order_status: DEFAULT_ORDER_STATUS,
        refund_status: DEFAULT_REFUND_STATUS
      }
      return cache
    })
  return fetchPromise
}



// WEBPACK FOOTER //
// ./src/utils/orderEnums.js